/* src/app/features/purchase-requests/shared/components/search/search.component.css */
.search-date {
  width: 238px;
}
.search-lookups {
  display: flex;
}
.lookup-input {
  width: 260px;
}
.buttons {
  justify-content: flex-end;
  margin-top: 50px;
}
.buttons > po-button {
  margin-right: 8px;
}
.switch {
  margin-top: 20px;
}
#defaultFilterContainer {
  display: flex;
  align-items: center;
  gap: 6px;
}
#defaultFilterContainer p {
  margin: 0;
}
#switchContainer {
  display: flex;
}
.projected-content {
  margin-left: auto;
  display: flex;
  align-items: center;
}
/*# sourceMappingURL=search.component.css.map */
